import { CoachingContext } from "../../../services/claude";
import { AttributeExamples } from "../types";
import { buildPerformanceAnalysisData } from "./buildPerformanceAnalysisData";
import { convertToAgentPerformanceAnalysis } from "./markdownConverter";

interface BuildCoachingContextParams {
  includeAttributeStats: boolean;
  attributeStatsContent: string | null;
  includeLensDefinition: boolean;
  lensDefinitionContent: string | null;
  includeTeamBestPractices: boolean;
  teamBestPracticesContent: string | null;
  attributeExamples: AttributeExamples[];
  selectedUserEmail?: string;
  lensName: string;
  timeRange: string;
  timezone: string;
}

export const buildCoachingContext = ({
  includeAttributeStats,
  attributeStatsContent,
  includeLensDefinition,
  lensDefinitionContent,
  includeTeamBestPractices,
  teamBestPracticesContent,
  attributeExamples,
  selectedUserEmail,
  lensName,
  timeRange,
  timezone
}: BuildCoachingContextParams): CoachingContext => {
  const context: CoachingContext = {};

  if (includeAttributeStats && attributeStatsContent) {
    const analysisData = buildPerformanceAnalysisData({
      attributeStatsContent,
      attributeExamples,
      selectedUserEmail,
      lensName,
      timeRange,
      timezone
    });

    const markdownContent = convertToAgentPerformanceAnalysis(analysisData);
    context.agentPerformanceAnalysis = markdownContent;
  }

  if (includeLensDefinition && lensDefinitionContent) {
    context.lensDefinition = lensDefinitionContent;
  }

  if (includeTeamBestPractices && teamBestPracticesContent) {
    context.teamBestPractices = teamBestPracticesContent;
  }

  return context;
};
